import React, { useEffect, useState } from 'react';
import { Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextareaAutosize, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';

export default function AttackModal({  attack, onTriggerCreate, onTriggerUpdate }) {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  
  const [formData, setFormData] = useState({
      id: '',
      label: '',
      value: '',
      active: false
  });

  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create Attack Type');    
    setFormData({ ...formData, id: '', label: '', value: '', active: '' });
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update  Attack Type');
    setFormData({ ...formData, id: attack.id, label: attack.label, value: attack.value, active: attack.active });
  }

  const handleUpdate = async (event) => {
      const result = await createAttackType(event);
      
      if (result === 'success') {
        setOpen(false);
        if ( title === 'Create Attack Type' ) {
          onTriggerCreate(formData);
        } else {
          onTriggerUpdate(formData);
        }      
      }
  }

  const handleClose = async () => {
    setOpen(false);
    if (formData.id === '') {    
      await setFormData({ ...formData, id: '', label: '', value: '', active: '' });
    }
  }
  
  const handleInputChange = (field) => (e) => {      

      const value = e.target.value;
      setFormData({ ...formData, [field]: value });
      
  }

  const createAttackType = async (event) => {
    event.preventDefault();
    let result = null;

    try {
        
        if (formData.id === '') {
          const response = await fetch(`${process.env.REACT_APP_API}/attackTypes/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
        } else {
            const response = await fetch(`${process.env.REACT_APP_API}/attackTypes/update`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
          }
          return result.message;
    } catch (error) {
      toast.error('Network error.  Please try again: ', error);
      return false;
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    if (attack.id !== undefined) {
      setFormData(attack);
    }     
    setLoading(false);
  }, [attack]);

if (!loading) {
  return (
      <>
          { formData.id === "" && 
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
              Add New
          </Button>
          }
          
          { formData.id !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
          }
          
          <Modal 
          open={open} 
          onClose={handleClose}
          style={{
              overlay: {
              backgroundColor: '#080030', // Semi-transparent black
              },
              content: {
              backgroundColor: '#080030',
              },
          }}
          >
              <Box sx={{color: 'white', p: 4 }}>
                  <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                      
                      mx: 'auto',
                      width: 400,
                      bgcolor: '#1e1e1e',
                      p: 2,
                  }}
                  >
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                      {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                      <Stack spacing={2}>
                      <TextField
                          required
                          fullWidth                          
                          label="Label"
                          value={formData.label}
                          onChange={handleInputChange('label')}
                          sx={ textFieldStyles }
                      >
                      </TextField>
                      <TextField
                          required
                          fullWidth
                          label="Value"
                          value={formData.value}
                          onChange={handleInputChange('value')}
                          sx={ textFieldStyles }
                      />
                      <TextField
                          select
                          required
                          fullWidth
                          label="Active"
                          value={formData.active}
                          onChange={handleInputChange('active')}
                          sx={ textFieldStyles }
                          >
                          {options.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                              {option.label}
                          </MenuItem>
                          ))}
                      </TextField>    
                      
                  
                  <ButtonGroup 
                      size="small"
                      variant="contained" 
                      aria-label="Basic button group" 
                      fullWidth
                      sx={{ mt:2 }}
                  >
                      <Button
                      onClick={handleClose}
                      type="cancel"
                      variant="contained"
                      sx={ Styles.buttonStyle }
                      >
                      Cancel
                      </Button>              
                      <Button
                      type="submit"                      
                      variant="contained"
                      sx={{ ...Styles.buttonStyle,  ml:4 }}
                      >
                      {title}
                      </Button>
                  </ButtonGroup>
                  </Stack>
              </Box>
              </Box>
          </Box>          
          </Modal>
      </>
  )}
}